const QuoteData = [
  {
    text: "Exige beaucoup de toi-même et attends peu des autres. Ainsi beaucoup d'ennuis te seront épargnés.",
    author: "Confucius",
  },
  {
    text: "Dans la vie on ne fait pas ce que l'on veut mais on est responsable de ce que l'on est.",
    author: "Jean-Paul Sartre",
  },
  {
    text: "La règle d'or de la conduite est la tolérance mutuelle, car nous ne penserons jamais tous de la même façon, nous ne verrons qu'une partie de la vérité et sous des angles différents.",
    author: "Gandhi",
  },
  {
    text: "La vie est un mystère qu'il faut vivre, et non un problème à résoudre.",
    author: "Gandhi",
  },
  {
    text: "Pour critiquer les gens il faut les connaître, et pour les connaître, il faut les aimer.",
    author: "Coluche",
  },
  {
    text: "On passe une moitié de sa vie à attendre ceux qu'on aimera et l'autre moitié à quitter ceux qu'on aime.",
    author: "Victor Hugo",
  },
  {
    text: "Le monde est dangereux à vivre ! Non pas tant à cause de ceux qui font le mal, mais à cause de ceux qui regardent et laissent faire.",
    author: "Albert Einstein",
  },
  {
    text: "La vie, c'est comme une bicyclette, il faut avancer pour ne pas perdre l'équilibre.",
    author: "Albert Einstein",
  },
  {
    text: "Le bonheur c'est lorsque vos actes sont en accord avec vos paroles.",
    author: "Indira Gandhi",
  },
  {
    text: "On ne souffre jamais que du mal que nous font ceux qu'on aime. Le mal qui vient d'un ennemi ne compte pas.",
    author: "Victor Hugo",
  },
];

export default QuoteData;



// WEBPACK FOOTER //
// ./src/data/quote.const.js